import { render, staticRenderFns } from "./AssignmentRatesList.vue?vue&type=template&id=12e30245&scoped=true&"
import script from "./AssignmentRatesList.vue?vue&type=script&lang=js&"
export * from "./AssignmentRatesList.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentRatesList.vue?vue&type=style&index=0&id=12e30245&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e30245",
  null
  
)

export default component.exports